import React, { Component } from 'react';
import { connect } from 'react-redux';

import ManageDashboard from './blocks/ManageDashboard';
import ManageExport from './blocks/ManageExport';
import ManageImport from './blocks/ManageImport';

import styles from './_styles/DdnyManage.module.scss';

const allActionCreators = Object.assign({});

export class DdnyManage extends Component {

	constructor(props) {

		super(props);

		this.state = {};
	}

	render() {

		return <div className={styles.DdnyManage}>
			<div className={styles.manageWrapper}>
				<div className={styles.dashboardSection}>
					<ManageDashboard />
				</div>
				<div className={styles.exportSection}>
					<ManageExport />
				</div>
				<div className={styles.importSection}>
					<ManageImport />
				</div>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(DdnyManage);